import { Injectable } from '@angular/core';
import * as CryptoJS from 'crypto-js';
import environment from '@environments';
import { IUser } from '@portal/entity-services/interfaces';


@Injectable({
  providedIn: 'root',
})
export class PremierPortalService {
  generateSsoRedirectUrl(user: IUser): string {
    const rawToken = localStorage.getItem('access_token');
    if (!rawToken) {
      throw new Error('No access token found in localStorage');
    }
    const tokenPayload = JSON.parse(atob(rawToken.split('.')[1]));

    const jwtPayload = {
      "sub": user.email,
      "entityId": tokenPayload.entity_id,
      "firstName": user.nameDetails?.firstName,
      "lastName": user.nameDetails?.lastName,
      "email": user.email,
      "roles": tokenPayload.roles,
      "iss": window.location.origin,
      "iat": Math.floor(Date.now() / 1000),
      "exp": Math.floor(Date.now() / 1000) + 3600,
    };

    const token = this.buildHmacJwt(
      jwtPayload,
      environment.PREMIER_PORTAL_CONFIG.jwtSecret,
    );
    return `${environment.PREMIER_PORTAL_CONFIG.url}?code=${token}`;
  }

  private buildHmacJwt(payload: object, secret: string): string {
    const encode = (obj: object): string => {
      const bytes = new TextEncoder().encode(JSON.stringify(obj));
      let binary = '';
      bytes.forEach((b) => (binary += String.fromCharCode(b)));
      return btoa(binary)
        .replace(/=/g, '')
        .replace(/\+/g, '-')
        .replace(/\//g, '_');
    };

    const header = { alg: 'HS256', typ: 'JWT' };
    const headerEncoded = encode(header);
    const payloadEncoded = encode(payload);
    const signingInput = `${headerEncoded}.${payloadEncoded}`;
    const signature = CryptoJS.HmacSHA256(signingInput, secret)
      .toString(CryptoJS.enc.Base64)
      .replace(/=/g, '')
      .replace(/\+/g, '-')
      .replace(/\//g, '_');

    return `${signingInput}.${signature}`;
  }
}
